var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.26 22.2503H8.74001C3.83001 22.2503 1.73001 20.1503 1.73001 15.2403V15.1103C1.73001 10.6703 3.48001 8.53027 7.40001 8.16027C7.80001 8.13027 8.18001 8.43027 8.22001 8.84027C8.26001 9.25027 7.96001 9.62027 7.54001 9.66027C4.40001 9.95027 3.23001 11.4303 3.23001 15.1203V15.2503C3.23001 19.3203 4.67001 20.7603 8.74001 20.7603H15.26C19.33 20.7603 20.77 19.3203 20.77 15.2503V15.1203C20.77 11.4103 19.58 9.93027 16.38 9.66027C15.97 9.62027 15.66 9.26027 15.7 8.85027C15.74 8.44027 16.09 8.13027 16.51 8.17027C20.49 8.51027 22.27 10.6603 22.27 15.1303V15.2603C22.27 20.1503 20.17 22.2503 15.26 22.2503Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.63C11.59 15.63 11.25 15.29 11.25 14.88V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2V14.88C12.75 15.3 12.41 15.63 12 15.63Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.7498C11.81 16.7498 11.62 16.6798 11.47 16.5298L8.12 13.1798C7.83 12.8898 7.83 12.4098 8.12 12.1198C8.41 11.8298 8.89 11.8298 9.18 12.1198L12 14.9398L14.82 12.1198C15.11 11.8298 15.59 11.8298 15.88 12.1198C16.17 12.4098 16.17 12.8898 15.88 13.1798L12.53 16.5298C12.38 16.6798 12.19 16.7498 12 16.7498Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/import-icon.03ed47bc.svg";
export { ForwardRef as ReactComponent };